var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_profile_div"},[(_vm.nav_bar=='base_info')?_c('BaseInfo'):_vm._e(),(_vm.nav_bar=='secret')?_c('Secret'):_vm._e(),(_vm.nav_bar=='mail_setting')?_c('MailSetting'):_vm._e(),(_vm.nav_bar=='code')?_c('Code'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }